import {arrive} from "../../../webui/js/dom/flow.js";

function gtag ()
{
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push(arguments)
}

const gtag_api = () => {
	window.dataLayer = window.dataLayer || []
	return function () {window.dataLayer.push(arguments)}
}

let gtag_is_initialized = false
const emplace_gtag = () => {
	if (!gtag_is_initialized)
	{
		window.arrive('script[data-privacy="tracking"]', (script) => {
			const new_script = script.cloneNode()
			new_script.removeAttribute('type')
			new_script.removeAttribute('data-privacy')

			new_script.setAttribute('src', new_script.getAttribute('data-src'))
			new_script.src = new_script.getAttribute('data-src')
			new_script.removeAttribute('data-src')

			script.parentNode.insertBefore(new_script, script.nextSibling);
		})

		const gtag = gtag_api()
		configure_gtag(gtag)
		gtag_is_initialized = true
	}
}

const configure_gtag = (gtag) => {
	gtag('js', new Date());
	gtag('config', config.ga_tracking_id, {
		'anonymize_ip': true,
		'wait_for_update': 500
	})
}

const config = {
	ga_tracking_id: undefined
}

const ga_opt_out = () => {
	throw_if_no_tracking_id()
	window[`ga-disable-${config.ga_tracking_id}`] = true;


}

const throw_if_no_tracking_id = () => {
	if (!config.ga_tracking_id) {
		throw new Error('opt-in: no value found for Google Analytics ID');
	}
}

const ga_opt_in = () => {

	window[`ga-disable-${config.ga_tracking_id}`] = false;

	emplace_gtag()
}

const scripts = []

function on_click_privacy_accept ()
{
	ga_opt_in()
}

function on_click_privacy_deny ()
{
	ga_opt_out()
}

export function emplace_privacy ({ga_tracking_id = undefined} = {})
{
	const is_local = Boolean(
	window.location.hostname === 'localhost' ||
	// [::1] is the IPv6 localhost address.
	window.location.hostname === '[::1]' ||
	// 127.0.0.1/8 is considered localhost for IPv4.
	window.location.hostname.match(
	/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
	));

	const subdomain = window.location.hostname.split('.').slice(0, -2).join('.')

	if (!is_local && (!subdomain || subdomain === 'www'))
	{
		if (!ga_tracking_id) {
			ga_tracking_id = document.documentElement.dataset.ga
		}

		if (ga_tracking_id) {
			config['ga_tracking_id'] = ga_tracking_id

			if (ga_allowed()) {
				ga_opt_in()
			}
			else {
				ga_opt_out()
			}
		}

		arrive('button[data-ui-privacy-accept]', (button) => {
			button.addEventListener('click', on_click_privacy_accept)
		})

		arrive('button[data-ui-privacy-deny]', (button) => {
			button.addEventListener('click', on_click_privacy_deny)
		})

		if (!privacy_data()) {
			show_privacy_modal();
		}
	}
}

function show_privacy_modal ()
{
	window.addEventListener('DOMContentLoaded', () => {
		arrive('[id="privacy-modal"]', (dialog) => {
			dialog.toggleAttribute('hidden')
			setTimeout(() => {
				window.requestAnimationFrame(() => {
					dialog.classList.add('ui-modal-active')
				})
			}, 1000)
		})
	})
}

function emplace_scripts ()
{
	alert(scripts.length)
}

export function local_storage_object_name ({ns_prefix = undefined} = {})
{
	return ns_prefix || cyrb53(window.location.host)
}


function privacy_data ()
{
	let pvy = document.cookie.split('; ').find((row) => row.startsWith('pvy='))?.split('=')[1];

	return pvy ? JSON.parse(decodeURIComponent(pvy)) : pvy
}

export function ga_allowed ({ns_prefix = undefined} = {})
{
	const pvy = privacy_data();
	return pvy && pvy['ga'] === 1;
}

/*export function accept_all_cookies ({ns_prefix = undefined} = {})
 {
 const ls_storage_name = local_storage_object_name({ns_prefix})
 const lsc_obj = JSON.stringify({
 accept_all: 1,
 })

 window.localStorage.setItem(ls_storage_name, lsc_obj)

 ga_opt_in()
 }*/

export function start_google_gtag ()
{
	const obj = {
		anonymize_ip: true,
		send_page_view: true,
	}

	const date = new Date
	gtag('js', date)

	if (!ga_allowed()) {
		gtag('consent', 'default',
		{
			'ad_storage': 'denied',
			'analytics_storage': 'denied'
		})

		obj['storage'] = 'none';
		obj['storage_gac'] = false;
		obj['client_storage'] = 'none';
	}

	gtag('config', config.ga_tracking_id, obj)
}

/*export function deny_all_cookies ({ns_prefix = undefined} = {})
 {
 const ls_storage_name = local_storage_object_name({ns_prefix})

 const lsc_obj = JSON.stringify({
 accept_all: 0,
 })

 window.localStorage.setItem(ls_storage_name, lsc_obj)
 }*/


/*export function configure_google_gtag (ga_tracking_id = 'UA-xxxxx-y',
 cid_expires_in_minutes = 525600, sid_expires_in_minutes = 30)
 {
 if (!window.localStorage) {
 return
 }

 const local_storage_object_name = 'ga_client_id'
 const local_storage_object_name_sid = 'ga_session_id'

 const date = new Date
 const now = date.getTime()
 gtag('js', date)

 gtag('consent', 'default',
 {
 'ad_storage': 'denied',
 'analytics_storage': 'denied'
 })

 let ls_cid // client id
 let json_obj = window.localStorage.getItem(local_storage_object_name) || '{}'
 let obj = JSON.parse(json_obj)
 if (obj.clientId && obj.expires) {
 if (now <= obj.expires) {
 ls_cid = obj.clientId
 }
 }

 let ls_sid
 let ls_sct = 1 // session count
 json_obj = window.localStorage.getItem(local_storage_object_name_sid) || '{}'
 obj = JSON.parse(json_obj)
 if (obj.sessionId && obj.expires) {
 if (now <= obj.expires) {
 ls_sid = obj.sessionId
 ls_sct = obj.sessionCount
 }
 else {
 ls_sct++
 }
 }

 if (!ls_cid)
 {
 ls_cid = client_id()

 const lsc_obj = JSON.stringify({
 clientId: ls_cid,
 expires: add_minutes(now, cid_expires_in_minutes)
 })

 window.localStorage.setItem(local_storage_object_name, lsc_obj)
 }

 if (!ls_sid)
 {
 ls_sid = session_id()
 const lsc_obj = JSON.stringify({
 sessionId: ls_sid,
 sessionCount: ls_sct,
 expires: add_minutes(now, sid_expires_in_minutes)
 })

 window.localStorage.setItem(local_storage_object_name_sid, lsc_obj)
 }

 gtag('config', ga_tracking_id, {
 storage: 'none',
 anonymize_ip: true,
 send_page_view: true,
 storage_gac: false,
 client_storage: 'none',
 client_id: ls_cid,
 session_id: ls_sid,
 session_number: ls_sct,
 })
 }*/

function add_minutes (time, minutes)
{
	return time + minutes * 60000
}

function client_id ()
{
	return id()
}

function session_id ()
{
	return id();
}

function id ()
{
	const seed = random_text()
	const id_source = seed + ";" + window.location.host + ";" + navigator.userAgent + ";" + navigator.language + ";"
	return cyrb53(id_source).toString(16)
}

function cyrb53 (str, seed = 0)
{
	let h1 = 0xdeadbeef ^ seed,
	h2 = 0x41c6ce57 ^ seed;
	for (let i = 0, ch; i < str.length; i++) {
		ch = str.charCodeAt(i);
		h1 = Math.imul(h1 ^ ch, 2654435761);
		h2 = Math.imul(h2 ^ ch, 1597334677);
	}
	h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
	h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
	return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

function random_text (min_len = 11, max_len = 11)
{
	"use strict";

	function genString ()
	{
		let array = new Uint8Array(max_len);
		window.crypto.getRandomValues(array);
		array = Array.apply([], array); /* turn into non-typed array */
		array = array.filter(function (x) {
			/* strip non-printables: if we transform into desirable range we have a propability bias, so I suppose we better skip this character */
			return x > 32 && x < 127;
		});
		return String.fromCharCode.apply(String, array);
	}

	let tmp = genString();
	while (tmp.length < min_len) {
		tmp += genString();
	}

	return tmp
}